module.exports = __webpack_public_path__ + "img/Prometheus.4f09229.svg";